var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LDDiscussionTeacherBar.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-c63d5416!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LDDiscussionTeacherBar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/liveDiscussion/components/LDDiscussionTeacherBar.vue
// module id = 1757
// module chunks = 61